<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2_txt1">Contents</h2>
<table cellpadding="0" cellspacing="0" width="100%">
<colgroup><col width="90%"/>
<col width="10%"/>
</colgroup><tbody><tr>
<td valign="top"><p class="running_first"><a href="#/xhtml/05_ch01">INTRODUCTION</a></p></td>
<td valign="top"><p class="running_first"><a href="#/xhtml/05_ch01">3</a></p></td>
</tr>
<tr>
<td valign="top"><p class="running_first"><span href="#/xhtml/86_ch82" title="Link target outside of Sample">IMAGE CREDITS</span></p></td>
<td valign="top"><p class="running_first"><span href="#/xhtml/86_ch82" title="Link target outside of Sample">118</span></p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_contents.vue?0aa2f692